import { fetcher } from "./fetcher"

const BASE_API_URL = process.env.GATSBY_WWW_URL

export type LocationResult = {
  success: true
  data: {
    location: string
  }
} | {
  success: false
  reason: Error
}

export const getLocationInfo = async (state: string | null): Promise<LocationResult> => {
  try {
    const url = new URL(`${BASE_API_URL}/api/v1/marketing/location`)

    if (state) {
      url.searchParams.set('state', state)
    }
    const response = await fetcher(url.toString())

    return Object.freeze({ success: true, data: response })
  } catch (cause) {
    const reason = cause instanceof Error ? cause : new Error(`cause: ${cause}`)

    return Object.freeze({ success: false, reason })
  }
}
